import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49d3b600"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "toolbar-wrapper" }
const _hoisted_2 = { class: "header__link_note" }
const _hoisted_3 = {
  key: 0,
  class: "text-primary q-ml-md"
}
const _hoisted_4 = { class: "header__username text-primary q-mr-md" }
const _hoisted_5 = { class: "text-h8" }

import {
  ref, watch, computed, onMounted,
} from 'vue';
import { getFullNameWithInitials } from '~utils/stringHelpers';
import { useAuthStore } from '@/store/auth/authModule';
import { usePaymentStore } from '@/store/payment/paymentModule';
import { storeToRefs } from 'pinia';

type MenuLink = {
  id: number,
  link: string,
  text: string,
  note?: string,
};


export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {

const store = useAuthStore();
const { userName } = storeToRefs(store);
const paymentStore = usePaymentStore();
const { branches, selectedBranch } = storeToRefs(paymentStore);

const getBranches = () => {
  paymentStore.getBranchList();
};

const createPayTicket = (branch: any) => {
  selectedBranch.value = branch;
  paymentStore.postQROnBnrach();
  const hoverSection = document.getElementById('toolbar-wrapper');
  hoverSection?.classList.remove('hover');
};
const visibleUserName = computed(() => {
  if (userName) {
    return getFullNameWithInitials(userName.value);
  }
  return '';
});

const logout = () => {
  useAuthStore().logout();
};

const menu: MenuLink[] = [
  {
    id: 1,
    link: '/qr',
    text: 'QR оплаты',
  },

];
const hoverEffect = () => {
  const hoverSection = document.getElementById('toolbar-wrapper');
  hoverSection?.classList.add('hover');
};
// const { currentOrg } = storeToRefs(useOrgsStore());

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_header = _resolveComponent("q-header")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_unref(store).isAuth)
      ? (_openBlock(), _createBlock(_component_q_header, {
          key: 0,
          elevated: "",
          class: "hidden-toolbar"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, { class: "bg-grey-3" }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menu, (item) => {
                  return _createVNode(_component_router_link, {
                    class: "header__link text-accent",
                    key: item.id,
                    to: item.link
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_btn, {
                        flat: "",
                        label: item.text
                      }, null, 8, ["label"]),
                      _createElementVNode("span", _hoisted_2, _toDisplayString(item.note ? [item.note] : ''), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                }), 64)),
                _createVNode(_component_q_btn_dropdown, {
                  color: "accent",
                  label: "Филиалы",
                  onClick: getBranches
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_list, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(branches), (branch) => {
                          return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                            clickable: "",
                            key: branch.ID,
                            onClick: ($event: any) => (createPayTicket(branch))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(branch.Name_branch), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])), [
                            [_directive_close_popup]
                          ])
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_unref(selectedBranch))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(selectedBranch).Name_branch), 1))
                  : _createCommentVNode("", true),
                _createVNode(_component_q_space),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(visibleUserName)), 1)
                ]),
                _createVNode(_component_q_btn, {
                  size: "sm",
                  push: "",
                  icon: "logout",
                  glossy: "",
                  color: "white",
                  "text-color": "accent",
                  label: "Выход",
                  onClick: logout
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_q_btn, {
      class: "row glossy q-ml-auto q-mr-xs q-mt-xs",
      round: "",
      color: "teal",
      icon: "menu",
      onClick: hoverEffect
    })
  ]))
}
}

})